<template>
<div class="container-fluid mt-5">
    <div class="col-12 text-right sticky-top mt-12">
        <base-button class="hover-apolo" type="default" icon size="sm" :class="{ invisible: !generateBillDisabled }">
            <span class="btn-inner--text">Monto total de ${{ factura.monto_total_boletos }}</span>
        </base-button>
    </div>
    <div>
    <card
        class="no-border-card"
        body-classes="px-0 pb-1"
        footer-classes="pb-2"
    >
        <template slot="header">
        <div class="row">
            <div class="col-6">
                <h3 class="mb-0">Facturación Global</h3>
            </div>
            <div class="col-6 text-right">
                <base-button :disabled="!generateBillDisabled" class="hover-apolo" type="default" icon size="sm" @click="generateBill = true">
                  <span class="btn-inner--icon"
                    ><i class="fas fa-plus"></i
                  ></span>
                  <span class="btn-inner--text">Generar Factura</span>
                </base-button>
                <base-button class="hover-apolo" type="default" icon size="sm" @click="getFacturasGlobales()">
                  <span class="btn-inner--icon"
                    ><i class="fas fa-plus"></i
                  ></span>
                  <span class="btn-inner--text">Ver Facturas</span>
                </base-button>
            </div>
        </div>
        </template>
        <div>
        <div
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap mb-3"
        >
        <multiselect class="col-3" v-model="status" :options="states" :close-on-select="true" :clear-on-select="false" :preserve-search="true" placeholder="Selecccionar agencia" track-by="value" label="nombre" :showLabels="false"></multiselect>
            
            <date-picker
              class="col-3"
              placeholder="Fecha inicio"
              v-model="fecha_inicio"
              :format="'DD-MM-YYYY'"
              :lang="'es'"
            ></date-picker>
            <date-picker
              class="col-3"
              placeholder="Fecha fin"
              v-model="fecha_fin"
              :format="'DD-MM-YYYY'"
              :lang="'es'"
            ></date-picker>
            <multiselect v-if="agencias" class="col-3 mt-2" v-model="agencia_id" :options="agencias" :close-on-select="true" :clear-on-select="false" :preserve-search="true" placeholder="Selecccionar agencia" track-by="id" label="nombre" :showLabels="false"></multiselect>
            <multiselect v-if="lineas" class="col-3 mt-2" v-model="linea" :options="lineas" :close-on-select="true" :clear-on-select="false" :preserve-search="true" placeholder="Selecccionar linea" track-by="id" label="nombre" :showLabels="false"></multiselect>
            <div class="col-3 mt-2"></div>
        </div>
        <div style="overflow-x: scroll; width: auto;"> 
            <el-table
                class="table-responsive align-items-center table-flush"
                header-row-class-name="thead-light"
                :data="facturas"
                @sort-change="sortChange"
                @selection-change="handleSelectionChange"
            >
                <div slot="empty" v-if="loading">
                <img src="/img/loading.gif" style="height: 100px; width: 100px" />
                </div>

                <div slot="empty" v-if="facturas">
                Sin datos disponibles
                </div>

                <el-table-column label="Facturar" type="selection"  :selectable="canSelectRow" />
                <el-table-column label="#" prop="id" min-width="100px"/>
                <el-table-column label="Nombre completo" prop="nombre_pasajero" min-width="200px"/>
                <el-table-column label="Fecha salida" min-width="180px">
                    <div slot-scope="{ row }">
                    <span v-if="row.fecha_salida">{{row.fecha_salida | moment('DD-MM-YYYY hh:mm')}}</span>
                    <span v-else> </span>
                    </div>
                </el-table-column>
                <el-table-column label="# Corrida" min-width="130px">
                    <div slot-scope="{ row }">
                    <span v-if="row.corrida">{{ row.corrida.id }}</span>
                    <span v-else> </span>
                    </div>
                </el-table-column>
                <el-table-column label="# Sub-Corrida" min-width="150px">
                    <div slot-scope="{ row }">
                    <span v-if="row.corrida">{{ row.subcorrida.id }}</span>
                    <span v-else> </span>
                    </div>
                </el-table-column>
                <el-table-column label="Asiento" min-width="110px">
                    <div slot-scope="{ row }">
                    <span v-if="row.asiento">{{ row.asiento }}</span>
                    <span v-else> </span>
                    </div>
                </el-table-column>
                <el-table-column label="Monto" min-width="110px">
                    <div slot-scope="{ row }">
                    <span v-if="row.monto">${{ row.monto }}</span>
                    <span v-else> </span>
                    </div>
                </el-table-column>
                <el-table-column label="Agencia" min-width="110px">
                    <div slot-scope="{ row }">
                    <span v-if="row.agencia">{{ row.agencia.nombre }}</span>
                    <span v-else> </span>
                    </div>
                </el-table-column>
                <el-table-column label="Reserva" min-width="180px">
                    <div slot-scope="{ row }">
                        <span>{{ row.status_reserva }}</span>
                    </div>
                </el-table-column>
                <el-table-column label="Liquidado" min-width="125px">
                    <div slot-scope="{ row }">
                        <span v-if="row.liquidado === 1">SI</span>
                        <span v-else>NO</span>
                    </div>
                </el-table-column>
                <el-table-column label="Abordado" min-width="125px">
                    <div slot-scope="{ row }">
                        <span v-if="row.abordado === 1">SI</span>
                        <span v-else>NO</span>
                    </div>
                </el-table-column>
                <el-table-column label="Facturado" min-width="130px">
                    <div slot-scope="{ row }">
                        <span v-if="row.facturado === 1">SI</span>
                        <span v-else>NO</span>
                    </div>
                </el-table-column>
                
            </el-table>
        </div>
        </div>
        <div
        slot="footer"
        class="col-12"
        >
        <el-select
            class="select-primary pagination-select"
            v-model="pagination.perPage"
            placeholder="Datos por página"
            >
            <el-option
                class="select-primary"
                v-for="item in pagination.perPageOptions"
                :key="item.value"
                :label="item.descripcion"
                :value="Number(item.value)"
            >
            </el-option>
        </el-select>
        <div class="justify-content-center d-flex flex-wrap">
            <base-pagination
            class="pagination-no-border"
            v-model="pagination.currentPage"
            :per-page="pagination.perPage"
            :total="total"
        />
        </div>
        
        </div>
    </card>
    </div>
    <!-- MODAL GENERAR FACTURA -->
    <modal :show.sync="generateBill" modal-classes="modal-primary">
      <h6 slot="header" class="mb-0 modal-title">Generar Factura Global</h6>
      <form class="new-event--form" @submit.prevent="">
        <validation-error :errors="apiValidationErrors.email_adicional" />
            <base-input label="Código postal"
                        placeholder="Código postal"
                        v-model="factura.cp"
                        input-classes="form-control-alternative new-event--title">
            </base-input>
            <base-input label="Calle"
                        placeholder="Calle"
                        v-model="factura.calle"
                        input-classes="form-control-alternative new-event--title">
            </base-input>
            <base-input label="Número"
                        placeholder="Número"
                        v-model="factura.numero"
                        input-classes="form-control-alternative new-event--title">
            </base-input>
            <base-input label="Colonia"
                        placeholder="Colonia"
                        v-model="factura.colonia"
                        input-classes="form-control-alternative new-event--title">
            </base-input>
            <base-input label="Estado"
                        placeholder="Estado"
                        v-model="factura.estado"
                        input-classes="form-control-alternative new-event--title">
            </base-input>
            <base-input label="Ciudad"
                        placeholder="Ciudad"
                        v-model="factura.ciudad"
                        input-classes="form-control-alternative new-event--title">
            </base-input>
        <multiselect class="mb-2" v-model="periodicidad" :options="periodicidades" :close-on-select="true" :clear-on-select="false" :preserve-search="true" placeholder="Selecccionar periodicidad" track-by="value" label="name" :showLabels="false"></multiselect>
        <multiselect class="mb-2" v-model="mes" :options="meses" :close-on-select="true" :clear-on-select="false" :preserve-search="true" placeholder="Selecccionar mes" track-by="value" label="name" :showLabels="false"></multiselect>
        <multiselect class="mb-2" v-model="metodo_pago" :options="metodos" :close-on-select="true" :clear-on-select="false" :preserve-search="true" placeholder="Selecccionar método de pago" track-by="name" label="name" :showLabels="false"></multiselect>
        <h4>Se generará factura global de los siguientes boletos: <span v-for="id in factura.boletos_ids">{{ id+',' }} por un monto total de: ${{ factura.monto_total_boletos }}</span> ¿estás seguro de facturar?</h4>
        <input type="hidden" class="new-event--start"/>
        <input type="hidden" class="new-event--end"/>
      </form>
      <template slot="footer">
        <button :disabled="!disabledInvoice" type="button" class="btn btn-primary hover-apolo" style="background-color: #0068a1 !important; color: white;" @click="facturaGlobal()">Facturar</button>
        <button type="button" class="btn btn-primary hover-apolo ml-auto" @click="close()">Cerrar</button>
      </template>
    </modal>
    <!-- MODAL VER FACTURAS GLOBALES -->
    <modal :show.sync="showInvoices" modal-classes="modal-primary" size="xl">
        <h6 slot="header" class="mb-0 modal-title">Ver Facturas Globales</h6>
        <form class="new-event--form" @submit.prevent="">
            <div class="row">
                <date-picker
                    class="col-2"
                    placeholder="Fecha inicio"
                    v-model="ver.fecha_inicio"
                    :format="'DD-MM-YYYY'"
                    :lang="'es'"
                ></date-picker>
                <date-picker
                    class="col-2"
                    placeholder="Fecha fin"
                    v-model="ver.fecha_fin"
                    :format="'DD-MM-YYYY'"
                    :lang="'es'"
                ></date-picker>
                <multiselect v-if="agencias" class="col-3" v-model="ver.agencia_id" :options="agencias" :close-on-select="true" :clear-on-select="false" :preserve-search="true" placeholder="Selecccionar agencia" track-by="id" label="nombre" :showLabels="false"></multiselect>
                <multiselect v-if="lineas" class="col-3" v-model="ver.linea_id" :options="lineas" :close-on-select="true" :clear-on-select="false" :preserve-search="true" placeholder="Selecccionar linea" track-by="id" label="nombre" :showLabels="false"></multiselect>
            </div>
            <el-table
                class="table-responsive align-items-center table-flush mt-3"
                header-row-class-name="thead-light"
                :data="facturasGlobales"
                >
                <div slot="empty" v-if="loading">
                    <img src="/img/loading.gif" style="height: 100px; width: 100px" />
                </div>
    
                <div slot="empty" v-if="facturasGlobales">
                    Sin datos disponibles
                </div>
                
                <el-table-column label="# Factura" prop="id" />
                <el-table-column label="Folios Boletos">
                    <div slot-scope="{ row }" class="row ml-1">
                        <div v-for="(folio, index) in row.folios_boletos">
                            <span>
                                <div v-if="(row.folios_boletos).length == (index+1)">{{ folio }}</div>
                                <div v-else class="mr-1">{{ folio+',' }} </div>
                            </span>
                        </div>
                    </div>
                </el-table-column>
                <el-table-column label="Fecha Facturación" prop="fecha_facturacion" />
                <el-table-column label="Monto Total" prop="monto_total" />
                <el-table-column align="center" min-width="180px">
                    <div slot-scope="{ row }" class="table-actions">
                        <span class="linkFactura" @click="downloadFacturaGlobal(row.facturapi_factura_id)">Descargar factura</span>
                    </div>
                </el-table-column>
            </el-table>
            <div slot="footer" class="col-12">
                <el-select
                    class="select-primary pagination-select"
                    v-model="pagination2.perPage"
                    placeholder="Datos por página"
                    >
                    <el-option
                        class="select-primary"
                        v-for="item in pagination2.perPageOptions"
                        :key="item.value"
                        :label="item.descripcion"
                        :value="Number(item.value)"
                    >
                    </el-option>
                </el-select>
                <div class="justify-content-center d-flex flex-wrap">
                    <base-pagination
                    class="pagination-no-border"
                    v-model="pagination2.currentPage"
                    :per-page="pagination2.perPage"
                    :tota2="total2"
                    />
                </div>
            </div>
            <input type="hidden" class="new-event--start"/>
            <input type="hidden" class="new-event--end"/>
        </form>

        <template slot="footer">
            <button type="button" class="btn btn-primary hover-apolo ml-auto" @click="close()">Cerrar</button>
        </template>
    </modal>
</div>
</template>
<script>
import Multiselect from 'vue-multiselect';
import formMixin from "@/mixins/form-mixin";
import ValidationError from "@/components/ValidationError.vue";
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import { BasePagination, Modal, BaseSwitch } from "@/components/";
import {
Table,
TableColumn,
DropdownMenu,
DropdownItem,
Dropdown,
Tooltip,
Select,
Option,
RadioButton,
Button,
} from "element-ui";
import swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.css";
import { throws } from 'assert';

export default {
layout: "DashboardLayout",

components: {
    ValidationError,
    Modal,
    Multiselect,
    DatePicker,
    BaseSwitch,
    BasePagination,
    [Tooltip.name]: Tooltip,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Select.name]: Select,
    [Option.name]: Option,
    [Button.name]: Button,
},

mixins: [formMixin],

data() {
    return {
        facturas: [],
        facturasGlobales: [],
        selectedRows: [],

        status: null,
        facturado: 0,
        factura_global: false,
        agencia_id: null,
        fecha_inicio: null,
        fecha_fin: null,
        mes: null,
        periodicidad: null,
        metodo_pago: null,
        lineas: null,
        linea: null,
        states: [
            { nombre: 'Todos los boletos', value: null},
            { nombre: 'Boletos Facturados Global', value: 1},
            { nombre: 'Boletos Sin Facturar', value: 0}
        ],
        periodicidades: [
            {name:'Diario', value: 'day'},
            {name:'Semanal', value: 'week'},
            {name:'Quincenal', value: 'fortnight'},
            {name:'Mensual', value: 'month'},
            {name:'Bimestral', value: 'two_months'}
        ],
        metodos: [
            {name:'Efectivo'},
            {name:'Transferencia electrónica de fondos'},
            {name:'Tarjeta de crédito'},
            {name:'Tarjeta de débito'},
            {name:'Por definir'},
        ],
        meses: [
            {name:'Enero', value: '01'},
            {name:'Febrero', value: '02'},
            {name:'Marzo', value: '03'},
            {name:'Abril', value: '04'},
            {name:'Mayo', value: '05'},
            {name:'Junio', value: '06'},
            {name:'Julio', value: '07'},
            {name:'Agosto', value: '08'},
            {name:'Septiembre', value: '09'},
            {name:'Octubre', value: '10'},
            {name:'Noviembre', value: '11'},
            {name:'Diciembre', value: '12'},
            {name:'Enero-Febrero', value: '13'},
            {name:'Marzo-Abril', value: '14'},
            {name:'Mayo-Junio', value: '15'},
            {name:'Julio-Agosto', value: '16'},
            {name:'Septiembre-Octubre', value: '17'},
            {name:'Noviembre-Diciembre', value: '18'}
        ],
        generateBill: false,
        showInvoices: false,

        sort: "created_at",

        pagination: {
            perPage: 5,
            currentPage: 1,
            perPageOptions: [{value:'5', descripcion: '5 facturas por página'},
            {value:'10', descripcion: '10 facturas por página'},
            {value:'25', descripcion: '25 facturas por página'},
            {value:'50', descripcion: '50 facturas por página'}],
        },
        total: 0,
        pagination2: {
            perPage: 5,
            currentPage: 1,
            perPageOptions: [{value:'5', descripcion: '5 facturas por página'},
            {value:'10', descripcion: '10 facturas por página'},
            {value:'25', descripcion: '25 facturas por página'},
            {value:'50', descripcion: '50 facturas por página'}],
        },
        total2: 0,
        loading: true,
        factura: {
            type: "facturación",
            metodo_pago: null,
            periodicidad: null,
            mes: null,
            boletos_ids: [],
            cp: '64400',
            calle: 'RUIZ CORTINEZ PTE',
            numero: '01857',
            colonia: 'ESTRELLA',
            estado: 'NUEVO LEON',
            ciudad: 'MONTERREY',
            monto_total_boletos: null
        },
        ver: {
            fecha_inicio: null,
            fecha_fin: null,
            agencia_id: null,
            linea_id: null
        },
        agencias: null
    };
},

computed: {
    from() {
        return this.pagination.perPage * (this.pagination.currentPage - 1);
    },

    to() {
        let highBound = this.from + this.pagination.perPage;
        if (this.total < highBound) {
            highBound = this.total;
        }
        return highBound;
    },
    generateBillDisabled(){
        if(this.factura.boletos_ids.length > 0){
            return true;                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                              
        } 
    },
    disabledInvoice(){
        if(this.periodicidad != null && this.mes != null && this.metodo_pago != null){
            return true;
        }
    }
},

watch: {
    status: {
        handler: "getListDebounced",
        immediate: true,
    },
    linea: {
        handler: "getListDebounced",
        immediate: true,
    },
    fecha_inicio: {
        handler: "getListDebounced",
        immediate: true,
    },
    fecha_fin: {
        handler: "getListDebounced",
        immediate: true,
    },
    agencia_id: {
        handler: "getListDebounced",
        immediate: true,
    },
    pagination: {
        handler: "getList",
        immediate: false,
        deep: true,
    },
    pagination2: {
        handler: "getList2",
        immediate: false,
        deep: true,
    },
    'ver.fecha_inicio':{
        handler: "getListDebounced2",
        immediate: false,
    },
    'ver.fecha_fin':{
        handler: "getListDebounced2",
        immediate: false,
    },
    'ver.agencia_id':{
        handler: "getListDebounced2",
        immediate: false,
    },
    'ver.linea_id':{
        handler: "getListDebounced2",
        immediate: false,
    }
},

created(){
    this.getAgencias();
    this.getLineas();
},

mounted(){
    this.status = this.states.find(option => option.value === null);
    this.fecha_fin = new Date(),
    this.fecha_inicio = new Date((this.fecha_fin.getMonth()+1)+' '+'1'+' '+this.fecha_fin.getFullYear());
},

methods: {
    async getLineas() {
      let params = {
        filter: {
        },
        page: {
          number: 1,
          size: 100000,
        },
      };
      await this.$store.dispatch("rutas/line", params).then(() => {
        this.lineas = this.$store.getters["rutas/line"];
      });
    },
    getListDebounced: _.debounce(function () {
        this.getList();
    }, 300),

    getListDebounced2: _.debounce(function () {
        this.getList2();
    }, 300),

    async getList() {
        var fecha_inicio_format = null;
        var fecha_fin_format = null;
        if(this.fecha_inicio != null){
            var fecha_inicio = this.fecha_inicio;
            fecha_inicio_format = fecha_inicio.getFullYear()  + "-" + ("0"+(fecha_inicio.getMonth()+1)).slice(-2) + "-" + ("0" + fecha_inicio.getDate()).slice(-2);
        }
        if(this.fecha_fin != null){
            var fecha_fin = this.fecha_fin;
            var fecha_hora = new Date(new Date().setHours(23,59,59,0));
            fecha_fin_format = fecha_fin.getFullYear()  + "-" + ("0"+(fecha_fin.getMonth()+1)).slice(-2) + "-" + ("0" + fecha_fin.getDate()).slice(-2);
        }
        if(fecha_inicio_format != null && fecha_fin_format != null){
            if(fecha_inicio_format > fecha_fin_format){
                this.$notify({
                    type: "danger",
                    message: "La fecha fin debe ser mayor que la fecha inicio",
                    duration: -1
                });
                return;
            }
        }
        
        if(this.status.value == 1){
            this.factura_global = true;
        }else{
            this.factura_global = false;
        }
        let params = {
            ...(this.sort ? { sort: this.sort } : {}),
            filter: {
            //...(this.search ? { search: this.search } : {}),
            ...(this.status ? { status: this.status.value } : {}),
            ...(this.facturado ? { facturado: this.facturado } : {}),
            ...(this.factura_global ? { factura_global: this.factura_global } : {}),
            ...(this.agencia_id ? { agencia_id: this.agencia_id.id } : {}),
            ...(this.linea ? { linea_id: this.linea.id } : {}),
            ...({ fecha_inicio: fecha_inicio_format }),
            ...( { fecha_fin: fecha_fin_format }),
            },
            page: {
                number: this.pagination.currentPage,
                size: this.pagination.perPage,
            },
        };
        await this.$store.dispatch("facturas/list", params).then(() => {
            this.facturas = this.$store.getters["facturas/list"];
            this.total = this.$store.getters["facturas/listTotal"];
        });
        this.loading = false;
    },

    async getList2() {
        var fecha_inicio_format = null;
        var fecha_fin_format = null;
        if(this.ver.fecha_inicio != null){
            var fecha_inicio = this.ver.fecha_inicio;
            fecha_inicio_format = fecha_inicio.getFullYear()  + "-" + ("0"+(fecha_inicio.getMonth()+1)).slice(-2) + "-" + ("0" + fecha_inicio.getDate()).slice(-2);
        }
        if(this.ver.fecha_fin != null){
            var fecha_fin = this.ver.fecha_fin;
            var fecha_hora = new Date(new Date().setHours(23,59,59,0));
            fecha_fin_format = fecha_fin.getFullYear()  + "-" + ("0"+(fecha_fin.getMonth()+1)).slice(-2) + "-" + ("0" + fecha_fin.getDate()).slice(-2);
        }
        if(fecha_inicio_format != null && fecha_fin_format != null){
            if(fecha_inicio_format > fecha_fin_format){
                this.$notify({
                    type: "danger",
                    message: "La fecha fin debe ser mayor que la fecha inicio",
                    duration: -1
                });
                return;
            }
        }
        let params = {
            filter: {
            //...({ factura_global: true }),
            ...(this.ver.agencia_id ? { agencia_id: this.ver.agencia_id.id } : {}),
            ...(this.ver.linea_id ? { linea_id: this.ver.linea_id.id } : {}),
            ...( { fecha_inicio: fecha_inicio_format } ),
            ...( { fecha_fin: fecha_fin_format }),
            },
            page: {
                number: this.pagination2.currentPage,
                size: this.pagination2.perPage,
            },
        };
        await this.$store.dispatch("facturas/listGlobal", params).then(() => {
            this.facturasGlobales = this.$store.getters["facturas/listGlobal"];
            this.total2 = this.$store.getters["facturas/listTotalGlobal"];
        });
        this.loading = false;
    },

    async getAgencias() {
      await this.$store.dispatch("agencias/listActive").then(() => {
        this.agencias = this.$store.getters["agencias/listActive"];
      });
    },

    handleSelectionChange(val){
        this.factura.boletos_ids = [];
        this.factura.monto_total_boletos = 0;
        for(let i = 0; i < val.length; i++){
            this.factura.boletos_ids.push(val[i].id);
            this.factura.monto_total_boletos = parseFloat(this.factura.monto_total_boletos) + parseFloat((val[i].monto));
        }
    },

    close(){
        if(this.showInvoices == true){
            this.showInvoices = false;
        }else{
            this.generateBill = false;
        }
    },

    canSelectRow(row, index) {
        return row.facturado !== 1 && row.liquidado !== 0;
    },

    async facturaGlobal(){
        this.factura.mes =  this.mes.value;
        this.factura.periodicidad =  this.periodicidad.value;
        this.factura.metodo_pago =  this.metodo_pago.name;
        
        try {
            await this.$store.dispatch("facturas/addGlobal", this.factura);
            this.$notify({
                type: "success",
                message: "Factura Global creada satisfactoriamente.",
                duration: -1
            });
            this.getList();
            this.close();
        } catch (error) {
            if(error.response.data.message != undefined){
                this.$notify({
                    type: "danger",
                    message: error.response.data.message +': '+error.response.data.error_details,
                    duration: -1
                });
            }
            if(error.response.data.errors != undefined){
                this.$notify({
                    type: "danger",
                    message: error.response.data.errors[0].detail,
                    duration: -1
                });
                this.resetApiValidation();
                this.setApiValidation(error.response.data.errors);
            }
        }
    },

    async getFacturasGlobales() {
        /*
        await this.$store.dispatch("facturas/listGlobal").then(() => {
            this.facturasGlobales = this.$store.getters["facturas/listGlobal"];
        });
        */
        this.ver.fecha_fin = new Date(),
        this.ver.fecha_inicio = new Date((this.fecha_fin.getMonth()+1)+' '+'1'+' '+this.fecha_fin.getFullYear());
        this.showInvoices = true;
    },

    async downloadFacturaGlobal(factura){
        await this.$store.dispatch("facturas/getFacturaGlobal", factura).then(() => {
           
        });
    },

    sortChange({ prop, order }) {
        if (order === "descending") {
            this.sort = `-${prop}`;
        } else {
            this.sort = `${prop}`;
        }
        this.getList();
    },
},
};
</script>
<style>
.linkFactura{
    color: blue;
    cursor: pointer;
}
.multiselect__select{
    right: 10px !important;
}
</style>